import React, { useState } from "react";
import { DiscussContent } from "./context";
import {
    CommonDiscussParams,
    convertDiscussDetail,
    getAskTeacherDetail,
    SortType,
    TopicType
} from "service/discuss";
import useRequest from "utils/useRequest";
import { getCourseInfo } from "service/course";
import scrollTo from "antd/lib/_util/scrollTo";

interface AskTeacherProviderProps extends CommonDiscussParams {
    topicType: TopicType; // 主题类型（0主题讨论 1答疑）
    uuid: string;
    children: React.ReactNode;
}

export function AskTeacherProvider({
    topicType,
    uuid,
    courseNo,
    courseSeq,
    batchNo,
    children
}: AskTeacherProviderProps) {
    const [sort, setSort] = useState(SortType.All);
    const [isWriting, setIsWriting] = useState(false);

    const [discussDetail, { loading }, updateDiscussDetail] = useRequest(
        async () => {
            return getAskTeacherDetail({
                uuid,
                courseNo,
                courseSeq,
                batchNo,
                sort
            });
        },
        {},
        [uuid, courseNo, courseSeq, batchNo, sort]
    );

    function onEditAnswer(isWriting: boolean) {
        setIsWriting(isWriting);

        if (isWriting) {
            const rect = document
                .querySelector("#DiscussTopic")!
                .getBoundingClientRect();

            scrollTo(rect.height + 80);
        }
    }

    const [course] = useRequest(() =>
        getCourseInfo({ courseNo, courseSeq, batchNo })
    );

    const [editUuid, setEditUuid] = useState<string | null>(null);

    return (
        <DiscussContent.Provider
            value={{
                topicType,
                uuid,
                courseNo,
                courseSeq,
                batchNo,
                sort,
                setSort,
                loading,
                isDead: false,
                editUuid,
                setEditUuid,
                isWriting,
                setIsWriting: onEditAnswer,
                course,
                discussDetail: discussDetail
                    ? convertDiscussDetail(discussDetail)
                    : undefined,
                updateDiscussDetail
            }}>
            {children}
        </DiscussContent.Provider>
    );
}
